/*
 * My Easy Monogram color swatches carry a generic alt="color" with no actual color name
 * anywhere in the DOM. The app's swatch images are named e.g. "Texture-Copper.png", so
 * the name is recovered from the filename and set as a native title-attribute tooltip.
 * The widget renders its swatches asynchronously after this script loads, hence the
 * MutationObserver.
 */
(function () {
  function colorNameFromSrc(src) {
    var match = src.match(/Texture-([^/.]+)\.[a-zA-Z]+(?:[?#].*)?$/);
    if (!match) return null;
    return match[1].replace(/[-_]+/g, ' ').trim();
  }

  function labelSwatch(img) {
    if (img.dataset.memNamed) return;
    var name = colorNameFromSrc(img.currentSrc || img.src);
    if (!name) return;
    img.title = name;
    var wrapper = img.closest('.preview-widget-individual-option-wrapper-swatch-images');
    if (wrapper) wrapper.title = name;
    img.dataset.memNamed = 'true';
  }

  function scan(root) {
    root.querySelectorAll('.preview-widget-individual-option-wrapper-swatch-images img').forEach(labelSwatch);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.mem_widget_ui');
    if (!root) return;

    scan(root);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.preview-widget-individual-option-wrapper-swatch-images img')) {
            labelSwatch(node);
          } else if (node.querySelectorAll) {
            scan(node);
          }
        });
      });
    }).observe(root, { childList: true, subtree: true });
  });
})();
